/* component-product-card-triggers.js
 * Quick-add / quick-view event dispatcher for product cards.
 * Self-loaded by snippets/product-card-vertical.liquid (and future overlay/inverted layouts).
 * Single global click listener via event delegation; safe to load multiple times
 * (IIFE-dedup-guarded per Rule J12).
 *
 * Event contract:
 *   document.dispatchEvent(new CustomEvent('quick-add:open', {
 *     detail: { productHandle: string, variantId: number | null }
 *   }));
 *   document.dispatchEvent(new CustomEvent('quick-view:open', {
 *     detail: { productHandle: string, variantId: number | null }
 *   }));
 *
 * Trigger element data attributes:
 *   data-quick-add-trigger / data-quick-view-trigger
 *   data-product-handle="<handle>"
 *   data-variant-id="<id>"  (optional)
 */
(function () {
  'use strict';

  if (window.__BLOCKDEDUP_PRODUCT_CARD_TRIGGERS__) {
    return;
  }
  window.__BLOCKDEDUP_PRODUCT_CARD_TRIGGERS__ = true;

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-quick-view-trigger]');
    if (!target) return;

    event.preventDefault();

    var productHandle = target.dataset.productHandle || '';
    var variantId = target.dataset.variantId ? parseInt(target.dataset.variantId, 10) : null;

    document.dispatchEvent(new CustomEvent('quick-view:open', {
      detail: {
        productHandle: productHandle,
        variantId: variantId
      }
    }));
  });
})();
